import { useEffect } from 'react'
import { useLanguage } from '@/contexts/LanguageContext'
import { useNotifications } from '@/contexts/NotificationContext'
import { ApiError } from '@/services/apiError'

/**
 * Hicbir yerde yakalanmamis hatalari kullaniciya duyurur.
 *
 * Neden: `window.onerror` ve `unhandledrejection` dinleyicisi yoktu; yakalanmamis
 * bir promise reddi kullaniciya hicbir iz birakmadan kayboluyordu.
 */
const GlobalErrorListener = (): null => {
  const { t } = useLanguage()
  const { notifyError } = useNotifications()

  useEffect(() => {
    const handleRejection = (event: PromiseRejectionEvent): void => {
      const reason = event.reason

      // 401 zaten login'e yonlendiriyor; ustune toast basmak gurultu olur.
      if (reason instanceof ApiError && reason.kind === 'auth') return

      console.error('[unhandledrejection]', reason)
      notifyError(t.errors.title, t.errors.generic)
    }

    const handleError = (event: ErrorEvent): void => {
      // Yalniz gercek script hatalari. `event.error` bos ise ya cross-origin
      // "Script error." ya da bir kaynak yukleme hatasidir (kirik gorsel gibi) --
      // bunlar icin kullaniciya toast basmak gurultuden ibaret olur.
      if (!event.error) return

      console.error('[window.onerror]', event.error)
      notifyError(t.errors.title, t.errors.generic)
    }

    window.addEventListener('unhandledrejection', handleRejection)
    window.addEventListener('error', handleError)
    return () => {
      window.removeEventListener('unhandledrejection', handleRejection)
      window.removeEventListener('error', handleError)
    }
  }, [notifyError, t])

  return null
}

export default GlobalErrorListener
